import { createContext, ReactNode, useContext } from 'react';
import { Choices } from '../../../common/Choice';
// import GrapesjsInput from '../GrapesjsInput';
import { CHOICES_BLOCK_TYPES } from './types';

interface Context {
    blockTypes: Choices
}

const DEFAULTCONTEXT: Context = {
    blockTypes: CHOICES_BLOCK_TYPES,
};

const BlockTypesContext = createContext<Context>(DEFAULTCONTEXT)

export const useBlockTypesContext = () => useContext(BlockTypesContext);

interface BlockTypesProviderProps {
    blockTypes?: Choices,
    children: ReactNode,
}

export const BlockTypesProvider = ({ children, blockTypes, ...rest }: BlockTypesProviderProps) => {
    return (
        <BlockTypesContext.Provider value={{
            blockTypes: blockTypes ? blockTypes : CHOICES_BLOCK_TYPES,
        }}>
            {children}
        </BlockTypesContext.Provider>
    )
}
